import { Component, OnInit } from '@angular/core';
import { ConfProyecto, SplashScreenService } from '@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16';
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = ConfProyecto.nombreAplicacion;
  public opacityChange = 0;
  loaderLogo = "/assets/images/logo-mini-md.png"
  public splashTransition: string;
  public showSplash = false;
  public splashdisplay = "none";
  public loaderMessage = "";
  appVersion = packageJson.version;


  constructor(
    private splashScreenStateService: SplashScreenService,
  ) {

  }

  readonly ANIMATION_DURATION = 1;


  ngOnInit(): void {
    this.splashScreenStateService.ocultar(() => {
      Promise.resolve().then(() => {
        this.hideSplashAnimation();
      });
    });

    this.splashScreenStateService.mostrar((res: any) => {
      Promise.resolve().then(() => {
        this.loaderMessage = res;
        this.showSplashAnimation();
      });
    });
  }

  private showSplashAnimation() {
    this.splashTransition = `opacity ${this.ANIMATION_DURATION}s`;
    this.opacityChange = 1;
    this.showSplash = true;
    this.splashdisplay = "flex"

  }

  private hideSplashAnimation() {
    // Setting the transition


    // After the transition is ended the showSplash will be hided
    this.splashTransition = `opacity ${this.ANIMATION_DURATION}s`;
    this.opacityChange = 0;
    this.splashdisplay = "none"
    this.showSplash = false;


  }

}
